module.exports = __webpack_public_path__ + "img/australia-liver-cancer-female.46e45448.png";